<form [formGroup]="feedbackInputForm" (ngSubmit)="onSubmit()">
  <ix-modal-content id="feedbackFormContent">
    {{ 'feedback.section_subheading' | translate }}

    <section>
      <ix-typography bold="true" format="h4" id="feedbackFormTopicOneHeader">
        {{ 'feedback.topic_one.heading' | translate }}
      </ix-typography>

      <ix-input
        [class.ix-invalid]="hasBeenSubmitted && feedbackInputForm.errors?.['noInput']"
        [invalidText]="'feedback.invalid_field_note' | translate"
        [label]="'feedback.topic_one.first_question' | translate"
        class="w-100 mt-2"
        formControlName="changeDataPoints"
        id="dataPoint"
        type="text"/>

      <ix-input
        [class.ix-invalid]="hasBeenSubmitted && feedbackInputForm.errors?.['noInput']"
        [invalidText]="'feedback.invalid_field_note' | translate"
        [label]="'feedback.topic_one.second_question' | translate"
        class="w-100 mt-2"
        formControlName="changeDescription"
        id="change"
        type="text"/>

    </section>

    <section>
      <ix-typography format="h4" id="feedbackFormTopicTwoHeader">
        {{ 'feedback.topic_two.heading' | translate }}
      </ix-typography>

      <ix-input
        [class.ix-invalid]="hasBeenSubmitted && feedbackInputForm.errors?.['noInput']"
        [invalidText]="'feedback.invalid_field_note' | translate"
        [label]="'feedback.topic_two.first_question' | translate"
        class="w-100 mt-2"
        formControlName="newDataPoints"
        id="newDataPoint"
        type="text"/>

    </section>
  </ix-modal-content>

  <ix-modal-footer>
    <ix-button (click)="onSubmit()"
               id="feedbackFormSubmitButton"
               onkeypress=""
               type="button"
               variant="primary">
      {{ 'feedback.submit' | translate }}
    </ix-button>
  </ix-modal-footer>
</form>
